const PassportPage = () => {
  return <div>Passport</div>;
};

export default PassportPage;
